// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"clt2g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _mergeProps = require("react-aria/mergeProps");
var _useLongPress = require("react-aria/useLongPress");
var _usePress = require("react-aria/usePress");
"use client";
function Example() {
    let [events, setEvents] = (0, _reactDefault.default).useState([]);
    let [mode, setMode] = (0, _reactDefault.default).useState('Activate');
    let { longPressProps } = (0, _useLongPress.useLongPress)({
        accessibilityDescription: 'Long press to activate hyper speed',
        onLongPressStart: (e)=>setEvents((events)=>[
                    `long press start with ${e.pointerType}`,
                    ...events
                ]),
        onLongPressEnd: (e)=>setEvents((events)=>[
                    `long press end with ${e.pointerType}`,
                    ...events
                ]),
        onLongPress: (e)=>{
            setMode('Hyper speed');
            setEvents((events)=>[
                    `long press with ${e.pointerType}`,
                    ...events
                ]);
        }
    });
    let { pressProps } = (0, _usePress.usePress)({
        onPress: (e)=>{
            setMode('Normal speed');
            setEvents((events)=>[
                    `press with ${e.pointerType}`,
                    ...events
                ]);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                ...(0, _mergeProps.mergeProps)(pressProps, longPressProps),
                children: mode
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                style: {
                    maxHeight: '200px',
                    overflow: 'auto'
                },
                children: events.map((e, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        children: e
                    }, i))
            })
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Example, {});

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria/mergeProps":"1CzGd","react-aria/useLongPress":"6QdMN","react-aria/usePress":"3vVrP","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"42COX":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkContext", ()=>LinkContext);
parcelHelpers.export(exports, "Link", ()=>Link);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _link = require("react-aria-components/Link");
var _skeleton = require("./Skeleton");
var _useDOMRef = require("./useDOMRef");
var _useLayoutEffect = require("react-aria/private/utils/useLayoutEffect");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const LinkContext = /*#__PURE__*/ (0, _react.createContext)(null);
const link = function anonymous(props, overrides) {
    let rules = " ";
    rules += (String(overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g) || []).join('');
    if (props.isFocusVisible) rules += ' _Lf16';
    else rules += ' _Le16';
    if (props.isStaticColor) rules += ' Oe16';
    else rules += ' Oh16';
    rules += ' OlOVIhfcebS7sd16';
    rules += ' OlOVIhfcebS7sd16';
    rules += ' _Mc16';
    rules += ' _Kd16';
    if (props.staticColor === "white") rules += ' -Ovbhqd-gcwrnr16';
    else if (props.staticColor === "black") rules += ' -Ovbhqd-g4hn3s16';
    rules += ' oR3ltQc16';
    rules += ' nR3ltQc16';
    rules += ' kR3ltQc16';
    rules += ' jR3ltQc16';
    if (props.isStandalone) {
        rules += ' uk16';
        rules += ' ucJ9TBTb16';
        rules += ' ud3Euai16';
        rules += ' uea16';
        rules += ' ugb16';
        rules += ' uhd16';
        rules += ' uje16';
        rules += ' u2NhKxcl16';
        rules += ' uic16';
    }
    if (props.isStandalone) {
        rules += ' -_6BNtrc-c16';
        rules += ' vFHT6Dd16';
    }
    if (props.isStandalone) {
        rules += ' xc16';
        rules += ' _xa16';
    }
    if (props.isStandalone) {
        rules += ' _Fd16';
        rules += ' _FnuYUweb16';
    }
    if (props.isStaticColor) rules += ' pl16';
    else if (props.variant === "secondary") {
        if (props.isPressed) rules += ' po16';
        else if (props.isFocusVisible) rules += ' po16';
        else if (props.isHovered) rules += ' po16';
        else rules += ' pt16';
    } else if (props.variant === "primary") {
        if (props.isPressed) rules += ' ps16';
        else if (props.isFocusVisible) rules += ' ps16';
        else if (props.isHovered) rules += ' ps16';
        else rules += ' pu16';
    }
    rules += ' plOVIhfcA5Qiqd16';
    rules += ' plOVIhfcA5Qiqd16';
    rules += ' Yd16';
    rules += ' Xb16';
    rules += ' _2b16';
    if (props.isStandalone) {
        if (props.isQuiet) {
            if (props.isFocusVisible) {
                rules += ' _Xb16';
                rules += ' __Va16';
            } else if (props.isHovered) {
                rules += ' _Xb16';
                rules += ' __Va16';
            } else rules += ' _Xa16';
        }
    } else {
        rules += ' _Xb16';
        rules += ' __Va16';
    }
    rules += ' __ca16';
    return rules;
};
const Link = /*#__PURE__*/ (0, _react.forwardRef)(function Link(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, LinkContext);
    let { variant = 'primary', staticColor, isQuiet, isStandalone, UNSAFE_style, UNSAFE_className = '', styles, children } = props;
    let domRef = (0, _useDOMRef.useFocusableRef)(ref);
    let isSkeleton = (0, _react.useContext)((0, _skeleton.SkeletonContext)) || false;
    [children, UNSAFE_style] = (0, _skeleton.useSkeletonText)(children, UNSAFE_style);
    (0, _useLayoutEffect.useLayoutEffect)(()=>{
        if (domRef.current) // TODO: should RAC Link pass through inert?
        domRef.current.inert = isSkeleton;
    }, [
        domRef,
        isSkeleton
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
        ...props,
        ref: domRef,
        style: UNSAFE_style,
        className: (renderProps)=>UNSAFE_className + link({
                ...renderProps,
                variant,
                staticColor,
                isStaticColor: !!staticColor,
                isQuiet,
                isStandalone,
                isSkeleton
            }, styles),
        children: children
    });
});

},{"0":"dGUmc","react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components/Link":"fOCdV","./Skeleton":"1mUnF","./useDOMRef":"9tqah","react-aria/private/utils/useLayoutEffect":"k6VV7","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dGUmc":[function() {},{}],"2mowY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BadgeContext", ()=>BadgeContext);
parcelHelpers.export(exports, "Badge", ()=>Badge);
var _jsxRuntime = require("react/jsx-runtime");
var _centerBaseline = require("./CenterBaseline");
var _slots = require("react-aria-components/slots");
var _filterDOMProps = require("react-aria/filterDOMProps");
var _icon = require("./Icon");
var _text = require("react-aria-components/Text");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _skeleton = require("./Skeleton");
var _content = require("./Content");
var _useDOMRef = require("./useDOMRef");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const BadgeContext = /*#__PURE__*/ (0, _react.createContext)(null);
const badge = function anonymous(props, overrides) {
    let rules = " ";
    let minWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "N") minWidth = true;
        rules += p[0];
    }
    if (props.size === "XL") {
        rules += ' uk16';
        rules += ' ucJ9TBTb16';
        rules += ' ud3Euai16';
        rules += ' uea16';
        rules += ' ugb16';
        rules += ' uhd16';
        rules += ' uje16';
        rules += ' u2NhKxcl16';
        rules += ' uic16';
    } else if (props.size === "L") {
        rules += ' uk16';
        rules += ' ucJ9TBTb16';
        rules += ' ud3Euai16';
        rules += ' uea16';
        rules += ' ugb16';
        rules += ' uhd16';
        rules += ' uje16';
        rules += ' u2NhKxcl16';
        rules += ' uic16';
    } else if (props.size === "S") {
        rules += ' uk16';
        rules += ' ucJ9TBTb16';
        rules += ' ud3Euai16';
        rules += ' uea16';
        rules += ' ugb16';
        rules += ' uhd16';
        rules += ' uje16';
        rules += ' u2NhKxcl16';
        rules += ' uic16';
    } else if (props.size === "XS") {
        rules += ' uk16';
        rules += ' ucJ9TBTb16';
        rules += ' ud3Euai16';
        rules += ' uea16';
        rules += ' ugb16';
        rules += ' uhd16';
        rules += ' uje16';
        rules += ' u2NhKxcl16';
        rules += ' uic16';
    } else {
        rules += ' uk16';
        rules += ' ucJ9TBTb16';
        rules += ' ud3Euai16';
        rules += ' uea16';
        rules += ' ugb16';
        rules += ' uhd16';
        rules += ' uje16';
        rules += ' u2NhKxcl16';
        rules += ' uic16';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e16';
        rules += ' vFHT6Dd16';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d16';
        rules += ' vFHT6Dd16';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b16';
        rules += ' vFHT6Dd16';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a16';
        rules += ' vFHT6Dd16';
    } else {
        rules += ' -_6BNtrc-c16';
        rules += ' vFHT6Dd16';
    }
    if (props.size === "XL") {
        rules += ' xb16';
        rules += ' _xa16';
    } else if (props.size === "L") {
        rules += ' xb16';
        rules += ' _xa16';
    } else if (props.size === "S") {
        rules += ' xb16';
        rules += ' _xa16';
    } else if (props.size === "XS") {
        rules += ' xb16';
        rules += ' _xa16';
    } else {
        rules += ' xb16';
        rules += ' _xa16';
    }
    if (props.size === "XL") {
        rules += ' _Fd16';
        rules += ' _FnuYUweb16';
    } else if (props.size === "L") {
        rules += ' _Fd16';
        rules += ' _FnuYUweb16';
    } else if (props.size === "S") {
        rules += ' _Fd16';
        rules += ' _FnuYUweb16';
    } else if (props.size === "XS") {
        rules += ' _Fd16';
        rules += ' _FnuYUweb16';
    } else {
        rules += ' _Fd16';
        rules += ' _FnuYUweb16';
    }
    if (props.fillStyle === "outline") rules += ' pm16';
    else if (props.fillStyle === "subtle") rules += ' pm16';
    else if (props.fillStyle === "bold") {
        if (props.variant === "celery") rules += ' pg16';
        else if (props.variant === "chartreuse") rules += ' pg16';
        else if (props.variant === "yellow") rules += ' pg16';
        else if (props.variant === "orange") rules += ' pg16';
        else if (props.variant === "notice") rules += ' pg16';
        else rules += ' px16';
    }
    rules += ' sd16';
    rules += ' ea16';
    rules += ' egLWx3bb16';
    rules += ' _oa16';
    rules += ' Sv16';
    rules += ' SgLWx3bd16';
    rules += ' Rv16';
    rules += ' RgLWx3bd16';
    if (props.size === "XL") {
        if (!minWidth) rules += ' NBaYFfc16';
    } else if (props.size === "L") {
        if (!minWidth) rules += ' N3JjxG16';
    } else if (props.size === "S") {
        if (!minWidth) rules += ' NCe2o8c16';
    } else if (props.size === "XS") {
        if (!minWidth) rules += ' NifsFYc16';
    } else if (!minWidth) rules += ' N4dY0ec16';
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec16';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn16';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b16';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd16';
    else rules += ' -SFnbic-_Jb16';
    rules += ' -Bu7z1c-oH5kTnc16';
    rules += ' oj16';
    rules += ' nj16';
    rules += ' kj16';
    rules += ' jj16';
    rules += ' qc16';
    rules += ' qsd16';
    rules += ' -Qg41Lb-IAxCW0c16';
    rules += ' -Qg41Lb-gLWx3bIYB8I16';
    rules += ' MAyFGYc16';
    rules += ' Td16';
    rules += ' Qd16';
    rules += ' -aRvJDd-Tu7Fubd16';
    rules += ' _Ca16';
    if (props.fillStyle === "outline") rules += ' g_g16';
    else if (props.fillStyle === "subtle") {
        if (props.variant === "silver") rules += ' g_f16';
        else if (props.variant === "cinnamon") rules += ' gP16';
        else if (props.variant === "brown") rules += ' gO16';
        else if (props.variant === "turquoise") rules += ' gy16';
        else if (props.variant === "pink") rules += ' gT16';
        else if (props.variant === "magenta") rules += ' gS16';
        else if (props.variant === "fuchsia") rules += ' gR16';
        else if (props.variant === "purple") rules += ' gM16';
        else if (props.variant === "indigo") rules += ' gK16';
        else if (props.variant === "blue") rules += ' gG16';
        else if (props.variant === "cyan") rules += ' gC16';
        else if (props.variant === "seafoam") rules += ' gz16';
        else if (props.variant === "green") rules += ' gA16';
        else if (props.variant === "celery") rules += ' gv16';
        else if (props.variant === "chartreuse") rules += ' gJ16';
        else if (props.variant === "yellow") rules += ' gW16';
        else if (props.variant === "orange") rules += ' gV16';
        else if (props.variant === "red") rules += ' gU16';
        else if (props.variant === "gray") rules += ' gI16';
        else if (props.variant === "negative") rules += ' gU16';
        else if (props.variant === "notice") rules += ' gV16';
        else if (props.variant === "positive") rules += ' gA16';
        else if (props.variant === "neutral") rules += ' gI16';
        else if (props.variant === "informative") rules += ' gG16';
        else if (props.variant === "accent") rules += ' gG16';
    } else if (props.fillStyle === "bold") {
        if (props.variant === "silver") rules += ' gm16';
        else if (props.variant === "cinnamon") rules += ' gq16';
        else if (props.variant === "brown") rules += ' gn16';
        else if (props.variant === "turquoise") rules += ' g516';
        else if (props.variant === "pink") rules += ' gx16';
        else if (props.variant === "magenta") rules += ' gD16';
        else if (props.variant === "fuchsia") rules += ' gr16';
        else if (props.variant === "purple") rules += ' go16';
        else if (props.variant === "indigo") rules += ' gl16';
        else if (props.variant === "blue") rules += ' g216';
        else if (props.variant === "cyan") rules += ' gk16';
        else if (props.variant === "seafoam") rules += ' g416';
        else if (props.variant === "green") rules += ' g116';
        else if (props.variant === "celery") rules += ' g716';
        else if (props.variant === "chartreuse") rules += ' gp16';
        else if (props.variant === "yellow") rules += ' gN16';
        else if (props.variant === "orange") rules += ' gQ16';
        else if (props.variant === "red") rules += ' gB16';
        else if (props.variant === "gray") rules += ' g616';
        else if (props.variant === "negative") rules += ' gB16';
        else if (props.variant === "notice") rules += ' gQ16';
        else if (props.variant === "positive") rules += ' g116';
        else if (props.variant === "neutral") rules += ' g616';
        else if (props.variant === "informative") rules += ' g216';
        else if (props.variant === "accent") rules += ' g216';
    }
    rules += ' _jf16';
    rules += ' _kJ8iPYd16';
    rules += ' hXMFGYc16';
    rules += ' mc16';
    rules += ' lc16';
    if (props.fillStyle === "outline") {
        if (props.variant === "negative") rules += ' iFLVMS16';
        else if (props.variant === "notice") rules += ' i9VrKkd16';
        else if (props.variant === "positive") rules += ' ip17Jm16';
        else if (props.variant === "neutral") rules += ' i0ruhAb16';
        else if (props.variant === "informative") rules += ' iG1ze4d16';
        else if (props.variant === "accent") rules += ' iG1ze4d16';
        else rules += ' iA16';
    } else rules += ' iA16';
    rules += ' -_8sjo0b-t5ZbAob16';
    if (props.size === "XL") rules += ' -M_-MBaYFfc16';
    else if (props.size === "L") rules += ' -M_-M3JjxG16';
    else if (props.size === "S") rules += ' -M_-MCe2o8c16';
    else if (props.size === "XS") rules += ' -M_-MifsFYc16';
    else rules += ' -M_-M4dY0ec16';
    rules += ' -_k_-_kc16';
    rules += ' -h_-hc16';
    return rules;
};
const Badge = /*#__PURE__*/ (0, _react.forwardRef)(function Badge(props1, ref) {
    [props1, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props1, ref, BadgeContext);
    let { children, variant = 'neutral', size = 'S', fillStyle = 'bold', overflowMode = 'wrap', ...otherProps } = props1; // useProviderProps(props) in v3
    let domRef = (0, _useDOMRef.useDOMRef)(ref);
    let isTextOnly = (0, _reactDefault.default).Children.toArray(props1.children).every((c)=>!/*#__PURE__*/ (0, _reactDefault.default).isValidElement(c));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _slots.Provider), {
        values: [
            [
                (0, _content.TextContext),
                {
                    styles: function anonymous(props) {
                        let rules = " ";
                        rules += ' TAzEcG16';
                        rules += ' QAzEcG16';
                        rules += ' _Jb16';
                        rules += ' _Nc16';
                        rules += ' Pc16';
                        rules += ' _Yb16';
                        if (props.overflowMode === "wrap") rules += ' _7b16';
                        else if (props.overflowMode === "truncate") rules += ' _7c16';
                        return rules;
                    }({
                        overflowMode
                    })
                }
            ],
            [
                (0, _text.TextContext),
                {}
            ],
            [
                (0, _icon.IconContext),
                {
                    render: (0, _centerBaseline.centerBaseline)({
                        slot: 'icon',
                        styles: " _Ja16"
                    }),
                    styles: " ZuUmpre16 FuUmpre16 I67logd16 _va16"
                }
            ]
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.SkeletonWrapper), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                ...(0, _filterDOMProps.filterDOMProps)(otherProps),
                role: "presentation",
                className: (props1.UNSAFE_className || '') + badge({
                    variant,
                    size,
                    fillStyle
                }, props1.styles),
                style: props1.UNSAFE_style,
                ref: domRef,
                children: typeof children === 'string' || isTextOnly ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                    children: children
                }) : children
            })
        })
    });
});

},{"0":"4Zx2m","1":"edtSF","2":"jeZxC","3":"i2kW3","react/jsx-runtime":"2Is6Z","./CenterBaseline":"1vpL9","react-aria-components/slots":"bA6Cz","react-aria/filterDOMProps":"c0Owd","./Icon":"jQAJE","react-aria-components/Text":"jt9fm","react":"a1TxN","./Skeleton":"1mUnF","./Content":"10r6w","./useDOMRef":"9tqah","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4Zx2m":[function() {},{}],"edtSF":[function() {},{}],"jeZxC":[function() {},{}],"i2kW3":[function() {},{}],"jAv02":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 18.78c-4.825 0-8.75-3.926-8.75-8.75S5.175 1.28 10 1.28s8.75 3.924 8.75 8.75-3.925 8.75-8.75 8.75m0-16c-3.998 0-7.25 3.251-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.253 7.25-7.25S13.998 2.78 10 2.78"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 14.384c0 .653.615 1.121 1.251.973 2.435-.566 4.249-2.75 4.249-5.357s-1.814-4.79-4.249-5.357c-.636-.148-1.251.32-1.251.973z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8rFkP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M10 6.35c2.012 0 3.65 1.638 3.65 3.65s-1.638 3.65-3.65 3.65S6.35 12.012 6.35 10 7.988 6.35 10 6.35m0-1.5c-2.84 0-5.15 2.31-5.15 5.15s2.31 5.15 5.15 5.15 5.15-2.31 5.15-5.15S12.84 4.85 10 4.85M10 3.25c-.414 0-.75-.336-.75-.75V1.25c0-.414.336-.75.75-.75s.75.336.75.75V2.5c0 .414-.336.75-.75.75M10 19.5c-.414 0-.75-.336-.75-.75V17.5c0-.414.336-.75.75-.75s.75.336.75.75v1.25c0 .414-.336.75-.75.75M2.5 10.75H1.25c-.414 0-.75-.336-.75-.75s.336-.75.75-.75H2.5c.414 0 .75.336.75.75s-.336.75-.75.75M18.75 10.75H17.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.25c.414 0 .75.336.75.75s-.336.75-.75.75M15.304 5.446c-.193 0-.384-.073-.53-.22-.294-.292-.294-.767 0-1.06l.883-.884c.293-.293.768-.293 1.06 0s.294.768 0 1.06l-.883.885c-.146.146-.338.22-.53.22M3.813 16.938c-.193 0-.384-.074-.53-.22-.294-.293-.294-.768 0-1.06l.883-.885c.293-.293.768-.293 1.06 0s.294.768 0 1.061l-.883.884c-.147.146-.338.22-.53.22M4.696 5.446c-.192 0-.383-.073-.53-.22l-.884-.883c-.293-.293-.293-.768 0-1.06s.768-.294 1.06 0l.885.883c.293.293.293.768 0 1.06-.147.147-.338.22-.53.22M16.188 16.938c-.193 0-.384-.074-.53-.22l-.885-.884c-.293-.293-.293-.768 0-1.06s.768-.294 1.061 0l.884.883c.293.293.293.768 0 1.06-.147.147-.338.22-.53.22"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bneuv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M16.25 14H3.75c-.414 0-.75.336-.75.75s.336.75.75.75h12.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75M3.75 5.5h12.5c.414 0 .75-.336.75-.75S16.664 4 16.25 4H3.75c-.414 0-.75.336-.75.75s.336.75.75.75M16.25 9H3.75c-.414 0-.75.336-.75.75s.336.75.75.75h12.5c.414 0 .75-.336.75-.75S16.664 9 16.25 9"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=useLongPress.db411571.js.map
